import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import { BASE_URL, DOMAIN_POOL_LIST, DOMAIN_POOL_ADD, DOMAIN_POOL_UPDATE, M_GET, M_POST } from '@/utils/api';
import type { IDomainPoolAdd, IDomainPoolUpdate } from '@/interface/DomainPool';

@Module({ name: 'domain-pool' })
export default class DomainPool extends VuexModule {
  @Action({ rawError: true })
  async FetchDomainList() {
    try {
      const { data } = await axios({
        url: BASE_URL + DOMAIN_POOL_LIST,
        method: M_GET
      });

      assertOk(data, 'Fetch domain pool failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Fetch domain pool failed');
    }
  }

  @Action({ rawError: true })
  async AddDomainList(params: IDomainPoolAdd) {
    try {
      const { data } = await axios({
        url: BASE_URL + DOMAIN_POOL_ADD,
        method: M_POST,
        data: params
      });

      assertOk(data, 'Add domain pool failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Add domain pool failed');
    }
  }

  @Action({ rawError: true })
  async UpdateDomainList(params: IDomainPoolUpdate) {
    try {
      const { data } = await axios({
        url: BASE_URL + DOMAIN_POOL_UPDATE,
        method: M_POST,
        data: params
      });

      assertOk(data, 'Update domain pool failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update domain pool failed');
    }
  }
}
